module.exports = __webpack_public_path__ + "img/machine_loading.5ef4a302.png";